// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1mu2R","col":"styles_col__u2Utc","fulfillmentStatus":"styles_fulfillmentStatus__1a4dJ","emailCol":"styles_emailCol__1twAT"};